import { render, staticRenderFns } from "./details-content-table.vue?vue&type=template&id=6dd6bbe0&scoped=true&"
import script from "./details-content-table.vue?vue&type=script&lang=js&"
export * from "./details-content-table.vue?vue&type=script&lang=js&"
import style0 from "./details-content-table.vue?vue&type=style&index=0&id=6dd6bbe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd6bbe0",
  null
  
)

export default component.exports